import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Error } from "src/app/api/models";
import { CONSOLE_VERSION } from "src/environments/version";

@Component({
  selector: "app-error-dialog",
  templateUrl: "./error-dialog.component.html",
  styleUrls: ["./error-dialog.component.scss"],
})
export class ErrorDialogComponent {
  /** The bundle this error happened on — always shown, for support correlation. */
  readonly version = CONSOLE_VERSION;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { error: Error; status?: number; requestId?: string }
  ) {}
}
